"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";

export function CardIconPrivateGarage({}) {
  return (
    <Block className={"amenity---icon"} tag={"div"}>
      <HtmlEmbed
        className={"html-embed-2"}
        content={
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" aria-labelledby="title">>\n<title id="title" lang="en">This community has private garages.</title>\n<path fill="currentColor" d="M0 171.3V488c0 13.3 10.7 24 24 24H72c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3zM128 224v96H512V224H128zm0 128V512H512V352H128zm128 80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16z"/></svg>'
        }
      />
    </Block>
  );
}
